import React, { useCallback, useMemo, useRef } from 'react';
import { Sprite, Text } from '@pixi/react';
import { observer } from 'mobx-react-lite';
import IconBackGround from '../../common/iconBackGround';
import { bettingPartStore } from '../../../store/bettingPartStore';
import { getGameImages } from '../../../core/helpers/getGameImages';
import { textureChangeFrame } from '../../../core/helpers/textureChangeFrame';
import { gameStore } from '../../../store/gameStore';
import { isMobile } from '../../../core/helpers/isMobile';

const AutoBetIcon = observer(({ x = 0, y = 0 }) => {
  const { isSpinStart, hasAutoBet, isSpinButtonHold } = gameStore;
  const {
    selectedAutoBetCount,
    setSelectedAutoBetCount,
    isAutoBetStart,
    setIsAutoBetStart,
    isOpenAutoBetPopup,
    setIsOpenAutoBetPopup,
  } = bettingPartStore;
  const iconRef = useRef();

  const { iconBgDefault, stopAutoBetIconBg, stopInfinityIcon, autoBetIcon } = useMemo(() => {
    return getGameImages();
  }, []);

  const handleSelectAutoBet = useCallback(
    (e) => {
      e.stopPropagation();
      if (isAutoBetStart) {
        setIsAutoBetStart(false);
        setSelectedAutoBetCount(null);
        setIsOpenAutoBetPopup(false);
      } else {
        textureChangeFrame(e.target.children[0], iconBgDefault);
        setIsOpenAutoBetPopup(!isOpenAutoBetPopup);
      }
    },
    [
      isAutoBetStart,
      setIsAutoBetStart,
      setSelectedAutoBetCount,
      setIsOpenAutoBetPopup,
      isOpenAutoBetPopup,
      iconBgDefault,
    ]
  );

  if (!hasAutoBet) {
    return null;
  }

  return (
    <IconBackGround
      y={y}
      x={x}
      handleSelect={handleSelectAutoBet}
      isSelect={isAutoBetStart}
      isDisabled={(isSpinStart || isSpinButtonHold) && !isAutoBetStart}
    >
      {isAutoBetStart && selectedAutoBetCount ? (
        <>
          <Sprite texture={stopAutoBetIconBg} anchor={0.5} scale={0.5} />
          {Number.isFinite(selectedAutoBetCount) ? (
            <Text
              text={selectedAutoBetCount}
              anchor={0.5}
              resolution={2}
              style={{
                fill: '#16181AD9',
                fontSize: 16,
                fontWeight: 500,
                fontFamily: 'poppinsMedium',
              }}
            />
          ) : (
            <Sprite texture={stopInfinityIcon} anchor={0.5} scale={isMobile() ? 0.77 : 0.5} />
          )}
        </>
      ) : (
        <Sprite ref={iconRef} anchor={0.5} texture={autoBetIcon} scale={isMobile() ? 0.77 : 0.5} />
      )}
    </IconBackGround>
  );
});

export default AutoBetIcon;
